// src/utils/initials.ts
// Iniciais do monograma de identidade no header (substitui o ícone de menu —
// não há endpoint de avatar nem foto de perfil no backend).
//
// Regra: primeira letra da PRIMEIRA palavra + primeira letra da ÚLTIMA palavra,
// ignorando partículas de ligação ("Raphael de Souza Fernandes" → "RF").
// Escolhida em vez de "as 2 primeiras letras do nome" porque distingue
// homônimos de primeiro nome, que é o caso comum num tenant.
//
// Partículas são descartadas apenas quando SOBRA alguma palavra — um nome que
// seja só partícula cai no conjunto original em vez de virar '?'.

const PARTICULAS = ['de', 'da', 'do', 'das', 'dos', 'e'];

/**
 * Retorna até 2 iniciais maiúsculas para o nome informado.
 * `'?'` quando o nome é vazio, nulo ou só espaços.
 */
export const initials = (fullName: string | null | undefined): string => {
  const palavras = (fullName ?? '').trim().split(/\s+/).filter(Boolean);
  const significativas = palavras.filter((p) => !PARTICULAS.includes(p.toLowerCase()));
  const base = significativas.length ? significativas : palavras;
  if (!base.length) return '?';

  const primeira = base[0];
  const ultima = base.length > 1 ? base[base.length - 1] : '';
  return `${primeira[0] ?? ''}${ultima[0] ?? ''}`.toUpperCase();
};
